import React, { useState } from "react";
import Helmet from "react-helmet";
import styled, { keyframes } from "styled-components/macro";

import { Title } from "../Styles/grid";

import USA from "../Data/usa-sku.json";
import Canada from "../Data/can-sku.json";

const price = ({ match }) => {
  // Deconstruct the router params coming in from the string
  const { params: part } = match;

  // use state context for sku
  const [sku, setSku] = useState(false);

  // Reducing the length param from xxmm to xx to help with matching
  const leng = part.leng;
  const str = leng.substring(0, leng.length - 2);

  // Massage the bit from xxxxxx-##xx to ##
  let hexBit = null;
  let imgr = null;
  const bitSplit = part.bit.split("-");
  if (bitSplit[0] !== "hex") {
    hexBit = bitSplit[1];
    imgr = bitSplit[0].replace(/torxs/gi, "torx");
  } else {
    const bit2 = part.hex
      .replace(/\+/gi, "")
      .replace(/in/gi, "")
      .replace(/mm/gi, "");
    const hex = bitSplit[0].toUpperCase();
    imgr = bitSplit[0];
    hexBit = hex.concat(bit2);
  }

  let filter = null
  // groupedsku
  if (localStorage.getItem("Country") === "USA") {
    filter = USA.find(bitt => bitt.sku.endsWith(`${hexBit}_${str}`));
  }
  if (localStorage.getItem("Country") === "Canada") {
    filter = Canada.find(bitt => bitt.sku.endsWith(`${hexBit}_${str}`));
  }

  //splitting out the sku and pack qty. from  a string ex. ("10,2,4,6")
  let gro = null;
  let sorting = null;
  let plub = null;
  let prbb = [];
  let secr = null;

  if (filter !== null) {
    const grouped = `${Array.of(filter.url)}`;
    const pack = `${Array.of(filter.pack)}`;
    const pric = `${Array.of(filter.prices)}`;
    const secret = `${Array.of(filter.grouped)}`;

    gro = grouped.split(",");
    sorting = pack.split(",");
    plub = pric.split(",")
    secr = secret.split(",");

    plub.forEach(function(bbb, i) {
     prbb[i] = bbb.substring(0,4)
    })
  }

  // looping through the new array and adding them to a master object
  let master = [];
  for (const i in sorting) {
    master[i] = {
      group: `${gro[i]}`,
      pack: `${sorting[i]}`,
      ppb: `${prbb[i]}`,
      secret: `${secr[i]}`
    };
  }
  // Sort array by value
  master.sort((a, b) => (parseInt(a.pack) > parseInt(b.pack) ? 1 : -1));

  // Main object
  const List = master.map((aaa, i) => {
    if (
      filter !== null &&
      aaa.pack !== "" &&
      (localStorage.getItem("Country") === "USA" ||
        localStorage.getItem("Country") === "Canada")
    ) {
      return (
        <ListStyle key={aaa.group}>
          <div>
            <strong>{aaa.pack} Pack</strong>
          </div>{" "}
          <strong>{localStorage.getItem("Country") === "Canada" ? ('CA$'):('$')}{aaa.ppb}</strong> &nbsp; per bit
          {localStorage.getItem("Country") === "USA" && sku === false ? (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`https://wihatools.com/${aaa.group}`}
              key={aaa.group}
            >
              Shop Now
            </a>
          ) : null}
          {localStorage.getItem("Country") === "Canada" && sku === false ? (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`https://wihatools.ca/${aaa.group}`}
              key={aaa.group}
            >
              Shop Now
            </a>
          ) : null}
          {sku && <Secret>#{aaa.secret}</Secret>}
          <Print>#{aaa.secret}</Print>
        </ListStyle>
      )
    } else {
      return false;
    }
  })

  return (
    <>
      <div>
        <Helmet>
          <title>Prices | Wiha BitFinder</title>
        </Helmet>
        {filter != null ? (
          <>
            <Toggle href="#" onClick={() => setSku(!sku)}>
              Show Part Number
            </Toggle>
            <Img
              src={`https://cdn.wihatoolsus.com/bit_images/${str}mm/${imgr}.jpg`}
            />
            {List}
          </>
        ) : (
          <Title>Sorry no product could be found for this selection.</Title>
        )}
      </div>
    </>
  );
};

export default price;

const opening = keyframes`
from {
    opacity: 0;
    transform: translate3d(2rem,0rem,0);
}
to {
    opacity: 1;
    transform: translate3d(0rem,0rem,0rem);
}
`;
const openingReverse = keyframes`
from {
    opacity: 0;
    transform: translate3d(-2rem,0rem,0);
}
to {
    opacity: 1;
    transform: translate3d(0rem,0rem,0rem);
}
`;

const ListStyle = styled.div`
  border: 1px solid #005fb2;

  padding: 1rem;
  margin: 1rem;

  display: flex;
  position: relative;

  overflow: hidden;

  transition: all 320ms linear;
  @media (min-width: 57rem) {
    animation: ${opening} 320ms linear;
  }

  div {
    color: #fff;

    background: rgba(0, 95, 178, 0.8);

    margin: -1rem 1rem -1rem -1rem;
    padding: 1.1rem 0.5rem;

    width: 6rem;

    text-align: center;
  }
  a {
    font-weight: bolder;
    text-transform: uppercase;

    display: block;
    position: absolute;
    right: 1rem;
    top: 0rem;

    height: 100%;
    padding-top: 1rem;

    color: #005fb2;
  }
  @media print {
    font-family: Georgia, "Times New Roman", Times, serif;
    border: none;

    div {
      color: #000;
      background: transparent;
    }
    strong {
      font-weight: normal;
    }

    a {
      display: none;
    }
  }
  @supports (clip-path: polygon(0 0, 0% 100%, 100% 0)) {
    @media (min-width: 57rem) {
      &::before {
        content: "";
        opacity: 0;
        transform: translate3d(-2rem, 0rem, 0rem);
        transition: all 200ms linear;
        width: 5%;
        height: 60%;
        background: rgba(0, 95, 178, 0.2);
        -webkit-clip-path: polygon(0 0, 0% 100%, 100% 0);
        clip-path: polygon(0 0, 0% 100%, 100% 0);
        position: absolute;
        top: 0;
        left: 6rem;
      }
      &::after {
        content: "";
        opacity: 0;
        transform: translate3d(2rem, 0rem, 0rem);
        transition: all 200ms linear;
        width: 5%;
        height: 40%;
        background: rgba(0, 95, 178, 0.2);
        -webkit-clip-path: polygon(100% 0, 0% 100%, 100% 100%);
        clip-path: polygon(100% 0, 0% 100%, 100% 100%);
        position: absolute;
        bottom: 0;
        right: 0;
      }

      &:hover::before {
        animation: ${openingReverse} 200ms linear;
        opacity: 1;
        transform: translate3d(0rem, 0rem, 0rem);
      }
      &:hover::after {
        animation: ${opening} 200ms linear;
        opacity: 1;
        transform: translate3d(0rem, 0rem, 0rem);
      }
    }
  }
  @media (max-width: 360px) {
    a {
      text-indent: -900000px;
      background: url("https://cdn.wihatoolsus.com/flags/shop.svg") no-repeat;
      margin-top: 12px;
      width: 30px;
      height: 30px;
    }
  }
`;
const Secret = styled.p`
  font-weight: bolder;
  text-transform: uppercase;

  display: block;
  position: absolute;
  right: 2rem;
  top: 0rem;

  color: #d71729;
`;

const Print = styled.span`
  display: none;
  @media print {
    display: block;
    position: absolute;
    right: 2rem;
    top: 0.9rem;
  }
`;

const Toggle = styled.a`
  color: #999999;
  font-weight: bold;
  font-size: 0.9rem;
  text-transform: uppercase;

  position: absolute;
  right: 1rem;
  top: -1rem;
`;

const Img = styled.img`
  display: block;
  margin: 3rem auto;
  transition: all 320ms linear;
  @media (min-width: 57rem) {
    animation: ${openingReverse} 200ms linear;
  }
`;
